import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0abab82b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0abab82b&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=0abab82b&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abab82b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abab82b')) {
      api.createRecord('0abab82b', component.options)
    } else {
      api.reload('0abab82b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0abab82b&scoped=true&", function () {
      api.rerender('0abab82b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/index.vue"
export default component.exports